import type { RiskFinancingRevalidationSummary } from './revalidationSummary.types'
import { useQuery } from '@tanstack/vue-query'
import { computed, type MaybeRefOrGetter, toValue } from 'vue'
import { queryKeys } from '~/queryClient'
import financialBff from '~/services-v2/financial-bff/financial-bff'
import { REVALIDATIONS_QUERY_STALE_MS } from './revalidationQuery.constants'

export default function useRevalidationSummary(enabled?: MaybeRefOrGetter<boolean>) {
  const queryEnabled = computed(() => {
    if (enabled === undefined)
      return true
    return Boolean(toValue(enabled))
  })

  return useQuery({
    queryKey: queryKeys.REVALIDATIONS.SUMMARY,
    enabled: queryEnabled,
    queryFn: async (): Promise<RiskFinancingRevalidationSummary> => {
      const res = await financialBff('query')({
        risk_financing_revalidation_summary: {
          total: true,
          statuses: {
            status: true,
            count: true,
          },
          brands: {
            brand: true,
            total: true,
            statuses: {
              status: true,
              count: true,
            },
          },
        },
      })

      const summary = res.risk_financing_revalidation_summary
      if (!summary)
        throw new Error('Resumo de revalidações: resposta vazia do BFF.')

      return summary as RiskFinancingRevalidationSummary
    },
    staleTime: REVALIDATIONS_QUERY_STALE_MS,
  })
}
